<template>
  <div>
    <h3>
      <p>
        {{ nome }}, bem-vindo ao Saia do Sofá
      </p><br>
    </h3>

    <p class="paragrafo">
      Estamos muito felizes em ter você conosco! Juntos, estamos construindo um Brasil mais informado e democrático. Ao
      se
      cadastrar, você dá o primeiro passo rumo a uma participação ativa na política do nosso país.
    </p>
    <p class="paragrafo">
      Acreditamos que a educação política é a única maneira de mudar o Brasil. Precisamos de um eleitor mais consciente
      e
      engajado. Aqui, você encontrará conteúdos, cursos e oportunidades para se aprofundar no conhecimento político e
      fazer a diferença.
    </p>
    <p class="paragrafo">
      Com o seu login você tem acesso a nossa área de cursos e conforme você vai se preparando pode ter acesso a mais
      níveis de informação.Quando você virar um Eleitor+, poderá acessar nosso movimento financeiro pois acreditamos que
      qualquer movimento público tem obrigação de ter total transparência.
      Para ter mais conteúdo e participação sugiro que comece a seguir as nossas redes. instagran e facebook
      @saiadosofabr
    </p>
    <p class="paragrafo">
      Além do canal no whatsapp, siga-nos nas redes sociais <br><br><social /><br>
      Fique de olho em nossas novidades e prepare-se para sair do sofá e entrar em ação!
    </p>
    <p>
      <i>
        <small>
          “Mudar o Brasil só depende de nós”
        </small>
      </i>
    </p>

  </div>
</template>

<script>
import Social from '../Social.vue';
export default {
  components: { Social },
  name: 'BoasVindas',
  props: {
    nome: String,
  }
}
</script>

<style></style>